package dk.smark.demo.map

sealed interface MapCommand {
    data class MoveCamera(val camera: MapCameraState) : MapCommand
    data class SelectMarker(val markerId: String) : MapCommand
    data object ZoomIn : MapCommand
    data object ZoomOut : MapCommand

    data object MapLoaded : MapCommand
}